import { Router, RootRoute, Route, redirect, createRoute } from "@tanstack/react-router";
import { Layout } from "./components/Layout";
import { LoginPage } from "./components/auth/LoginPage";
import { NotFound } from "./components/NotFound";
import { AppointmentsView } from "./components/AppointmentsView";
import AppointmentsOverviewTable from "./components/Appointments/AppointmentsRecord/AppointmentsOverviewTable";
import { DoctorsView } from "./components/DoctorsView";
import { PatientsView } from "./components/PatientsView";
import { ClinicsView } from "./components/ClinicsView";
// import { SupervisorView } from "./components/SupervisorView";
import { OverviewView } from "./components/OverviewView";
import { MedicalCampView } from "./components/MedicalCampView";
import { DoctorLoginView } from "./components/DoctorLoginView";
import { StockDashboardView } from "./components/Inventory-Stocks & Orders/StockDashboardView";
import { StockCategoriesView } from "./components/Inventory-Stocks & Orders/Admin/StockCategoriesView";
import { StockProductsView } from "./components/Inventory-Stocks & Orders/Admin/Products/StockProductsView";
import { StockLabTestsView } from "./components/Inventory-Stocks & Orders/StockLabTestsView";
import { StockPromotionsView } from "./components/Inventory-Stocks & Orders/StockPromotionsView";
import { PrivacyPolicyPage } from "./components/PrivacyPolicyPage";
import { BuggyComponent } from "./Bug";
import StockMedicineView from "./components/Inventory-Stocks & Orders/StockMedicineView";
import InventoryManagement from "./components/Inventory-Stocks & Orders/Admin/InventoryManagement/InventoryManagement";
import MedicalOrdersApp from "./components/Inventory-Stocks & Orders/Admin/StockOrder/OrderInfo/Main";
import DeliveryBoyPage from "./components/Inventory-Stocks & Orders/Clinic/Driver/OrderDeliveryBoysState";
import { StockOrdersView } from "./components/Inventory-Stocks & Orders/Clinic/ClinicOrder/StockOrders";
import { DriverListing } from "./components/Inventory-Stocks & Orders/Admin/Driver/DriverListingMain";
import { ClinicStockDashboardView } from "./components/Inventory-Stocks & Orders/ClinicStockDashboardView";
import LabMain from "./components/LabTest/LabMain";
import { ClinicInventoryManagement } from "./components/Inventory-Stocks & Orders/Clinic/ClinicInventoryManagement";
import { PreviewFiles } from "./components/Inventory-Stocks & Orders/Admin/StockOrder/OrderInfo/PreviewFile";
import { BlogsView } from "./components/BlogsView";
import OnlineOrder from "./components/Inventory-Stocks & Orders/Clinic/ClinicOrder/OnlineOrder/OnlineOrder";
import OfflineOrder from "./components/Inventory-Stocks & Orders/Clinic/ClinicOrder/OfflineOrders/OfflineOrder";
import LabtestOrder from "./components/Inventory-Stocks & Orders/Clinic/ClinicOrder/LabtestOrders/LabtestOrder";
import OfflineLabtestOrderPage from "./components/Inventory-Stocks & Orders/Clinic/ClinicOrder/OfflineLabtest/OfflineLabtestOrderPage";
import AdminOnlineOrder from "./components/Inventory-Stocks & Orders/Admin/Orders/Online/OnlineOrder";
import AdminOfflineOrder from "./components/Inventory-Stocks & Orders/Admin/Orders/Offline/AdminOfflineOrder";
import AdminLabtestOrder from "./components/Inventory-Stocks & Orders/Admin/Orders/Labtest/LabtestOrder";
import VideoBlogs from "./components/VideoBlogs";
import OrderReport from "./components/Report/Orders/OrderReport";
import LabtestReport from "./components/Report/Labtests/LabtestReport";
import AppointmentReport from "./components/Report/Appointment/AppointmentReport";
import DaywiseReport from "./components/Report/Daywise/DaywiseReport";
import StockReport from "./components/Report/Stocks/StockReport";
import AvailableStockReport from "./components/Report/AvailableStock/AvailableStockReport";
import AppointmentDetailsLayout from "./components/Appointments/AppointmentDetails/AppointmentDetailsLayout";
import OrderManagement from "./components/OrderManagement/OrderManagement";
import { SearchAnalyticsView } from "./components/Analytics/SearchAnalyticsView";
import { ProductEnquiryAnalyticsView } from "./components/Analytics/ProductEnquiryAnalyticsView";
import { ReviewAnalyticsView } from "./components/Analytics/ReviewAnalyticsView";
import TransactionHistoryPage from "./components/TransactionHistory/TransactionHistoryPage";
import { ClinicStaffPage } from "./components/Staff/ClinicStaffPage";
import { AdminStaffPage } from "./components/Staff/AdminStaffPage";

const isLoggedIn = () => Boolean(localStorage.getItem("auth_user"));

const getUserRole = () => {
  const authUser = localStorage.getItem("auth_user");
  if (!authUser) return null;

  try {
    const user = JSON.parse(authUser);
    return user.role?.toLowerCase();
  } catch (e) {
    console.log("FROM ROUTER FILE", e);
    return null;
  }
};

const rootRoute = new RootRoute({
  notFoundComponent: NotFound,
  errorComponent: BuggyComponent,
});

const clinicLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "clinic/login",
  component: LoginPage,
  beforeLoad: () => {
    if (isLoggedIn()) {
      const role = getUserRole();
      throw redirect({ to: `/${role || "clinic"}/dashboard` });
    }
  },
});

const adminLoginRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "admin/login",
  component: LoginPage,
  beforeLoad: () => {
    if (isLoggedIn()) {
      const role = getUserRole();
      throw redirect({ to: `/${role || "admin"}/dashboard` });
    }
  },
});

const campLoginRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "medicalcamp/login",
  component: LoginPage,
  beforeLoad: () => {
    if (isLoggedIn()) {
      const role = getUserRole();
      throw redirect({ to: `/${role || "medicalcamp"}/dashboard` });
    }
  },
});

const labLoginRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "lab/login",
  component: LoginPage,
  beforeLoad: () => {
    if (isLoggedIn()) {
      const role = getUserRole();
      throw redirect({ to: `/${role || "lab"}/dashboard` });
    }
  },
});

const doctorRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "doctor",
  component: DoctorLoginView,
});

// Catch all routes under /doctor/*
const doctorCatchAllRoute = new Route({
  getParentRoute: () => doctorRoute,
  path: "$",
  component: DoctorLoginView,
});

const privacyPolicyRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "privacy-policy",
  component: PrivacyPolicyPage,
  beforeLoad: () => {
    // Allow access to privacy policy without authentication
    return;
  },
});

const authenticatedRoute = new Route({
  getParentRoute: () => rootRoute,
  id: "authenticated",
  component: Layout,
});

const clinicRoute = new Route({
  getParentRoute: () => authenticatedRoute,
  path: "clinic",
});

const clinicDashboardRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "dashboard",
  component: OverviewView,
});

const clinicAppointmentsRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "appointments",
  component: AppointmentsView,
});

const clinicAppointmentsOverviewRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "appointments/overview",
  component: AppointmentsOverviewTable,
});

const clinicAppointmentsDetailsRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "appointments/$appointmentId",
  component: AppointmentDetailsLayout,
});

const clinicDoctorsRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "doctors",
  component: DoctorsView,
});

const clinicPatientsRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "patients",
  component: PatientsView,
});

const clinicStaffRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "staff",
  component: ClinicStaffPage,
});

const ClinicOrdersDashboardRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/stocks-orders/dashboard",
  component: ClinicStockDashboardView,
});

const ClinicOrdersRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/stocks-orders/orders",
  component: StockOrdersView,
});

const ClinicMedicineOrderReportRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/reports/medicine-order",
  component: OrderReport,
});

const ClinicLabTestOrderReportRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/reports/labtest-order",
  component: LabtestReport,
});
const ClinicAppointmentReportRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/reports/appointment",
  component: AppointmentReport,
});
const AdminAppointmentReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/appointment",
  component: AppointmentReport,
});
const AdminMedicineOrderReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/medicine-order",
  component: OrderReport,
});
const AdminLabTestOrderReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/labtest-order",
  component: LabtestReport,
});
const AdminDaywiseReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/daywise",
  component: DaywiseReport,
});

const AdminStockReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/stock-report",
  component: StockReport,
});

const AdminAvailableStockReportRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/reports/available-stock",
  component: AvailableStockReport,
});
// const ClinicOrdersProductsRoute = new Route({
//   getParentRoute: ()=> clinicRoute,
//   path:'/stocks-orders/products',
//   component:StockProductsView
// })
const ClinicOrdersLabTestsRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/stocks-orders/lab-tests",
  component: StockLabTestsView,
});
const ClinicOrdersDeliveryBoysRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/stocks-orders/delivery-boys",
  component: DeliveryBoyPage,
});
const ClinicDaywiseReportRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/reports/daywise",
  component: DaywiseReport,
});

const ClinicStockReportRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/reports/stock-report",
  component: StockReport,
});

const ClinicOnlineOrderRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: '/stocks-orders/online-orders',
  component: OnlineOrder
})

const ClinicOfflineOrderRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: '/stocks-orders/offline-orders',
  component: OfflineOrder
})

const ClinicLabTestOrderRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: '/stocks-orders/labtest-orders',
  component: LabtestOrder
})

const clinicTransactionHistoryRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "transaction-history",
  component: TransactionHistoryPage,
});

const ClinicOfflineLabTestOrderRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: '/stocks-orders/offline-labtest-orders',
  component: OfflineLabtestOrderPage
})

const adminRoute = new Route({
  getParentRoute: () => authenticatedRoute,
  path: "admin",
});

const adminDashboardRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "dashboard",
  component: OverviewView,
});


const blogRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/blogs",
  component: BlogsView,
});

const adminSearchAnalyticsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/analytics/search-analytics",
  component: SearchAnalyticsView,
});

const adminProductEnquiryAnalyticsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/analytics/product-enquiry",
  component: ProductEnquiryAnalyticsView,
});

const adminReviewAnalyticsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/analytics/review-analytics",
  component: ReviewAnalyticsView,
});


const adminAppointmentsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "appointments",
  component: AppointmentsView,
});

const videoBlogsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "video-blogs",
  component: VideoBlogs,
});

const adminAppointmentsOverviewRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "appointments/overview",
  component: AppointmentsOverviewTable,
});

const adminAppointmentsDetailsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "appointments/$appointmentId",
  component: AppointmentDetailsLayout,
});

const adminDoctorsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "doctors",
  component: DoctorsView,
});

const adminPatientsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "patients",
  component: PatientsView,
});

const adminStocksDeliveryBoysRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/delivery-boys",
  component: DriverListing,
});

const adminStaffRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "staff",
  component: AdminStaffPage,
});

const adminClinicsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "clinics",
  component: ClinicsView,
});

// const adminSupervisorRoute = new Route({
//   getParentRoute: () => adminRoute,
//   path: "supervisors",
//   component: SupervisorView
// });

const adminMedicalCampRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "medicalcamp",
  component: MedicalCampView,
});

const campRoute = new Route({
  getParentRoute: () => authenticatedRoute,
  path: "medicalcamp",
});

const labRoute = new Route({
  getParentRoute: () => authenticatedRoute,
  path: "lab",
});

const campDashboardRoute = new Route({
  getParentRoute: () => campRoute,
  path: "dashboard",
  component: OverviewView,
});

const campAppointmentsRoute = new Route({
  getParentRoute: () => campRoute,
  path: "appointments",
  component: AppointmentsView,
});
const campAppointmentsOverviewRoute = new Route({
  getParentRoute: () => campRoute,
  path: "appointments/overview",
  component: AppointmentsOverviewTable,
});

const campAppointmentsDetailsRoute = new Route({
  getParentRoute: () => campRoute,
  path: "appointments/$appointmentId",
  component: AppointmentDetailsLayout,
});

const campDoctorsRoute = new Route({
  getParentRoute: () => campRoute,
  path: "doctors",
  component: DoctorsView,
});

const campPatientsRoute = new Route({
  getParentRoute: () => campRoute,
  path: "patients",
  component: PatientsView,
});

const adminStocksDashboardRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/dashboard",
  component: StockDashboardView,
});

const adminStocksInventoryManagementRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/inventory-management",
  component: InventoryManagement,
});

const adminStocksOrdersRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/orders",
  component: MedicalOrdersApp,
});

const adminStocksOnlineOrdersRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/online-orders",
  component: OrderManagement,
});

const adminStockLabtestOrderRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/labtest-orders",
  component: AdminLabtestOrder,
});

const adminOfflineLabtestOrderRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/offline-labtest-orders",
  component: OfflineLabtestOrderPage,
});

const adminStocksOfflineOrdersRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/offline-orders",
  component: AdminOfflineOrder,
});

const adminStocksCategoriesRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/categories",
  component: StockCategoriesView,
});
const adminStocksProductsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/products",
  component: StockProductsView,
});
const adminStocksLabTestsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/lab-tests",
  component: StockLabTestsView,
});

const adminStocksMedicineRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/medicine",
  component: StockMedicineView,
});

// const adminStocksNewItemRoute = new Route({
//   getParentRoute: ()=> adminRoute,
//   path:'/stocks-orders/items',
//   component:AddNewItems
// })
const adminStocksPromotionsRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/stocks-orders/promotions",
  component: StockPromotionsView,
});

const labDashboardRoute = new Route({
  getParentRoute: () => labRoute,
  path: "dashboard",
  component: LabMain,
});

const clinicStocksInventoryManagementRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/stocks-orders/inventory-management",
  component: ClinicInventoryManagement,
});

const clinicImagePreviewRoute = new Route({
  getParentRoute: () => clinicRoute,
  path: "/image-preview",
  component: PreviewFiles,
});
const adminImagePreviewRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/image-preview",
  component: PreviewFiles,
});

const adminTransactionHistoryRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "transaction-history",
  component: TransactionHistoryPage,
});

const adminOrderManagementRoute = new Route({
  getParentRoute: () => adminRoute,
  path: "/order-management",
  component: OrderManagement,
});

const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    if (isLoggedIn()) {
      const role = getUserRole();
      throw redirect({ to: `/${role || "clinic"}/dashboard` });
    } else {
      throw redirect({ to: "/clinic/login" });
    }
  },
});



const routeTree = rootRoute.addChildren([
  indexRoute,
  clinicLoginRoute,
  adminLoginRoute,
  campLoginRoute,
  labLoginRoute,
  privacyPolicyRoute,
  doctorRoute.addChildren([doctorCatchAllRoute]),
  authenticatedRoute.addChildren([
    clinicRoute.addChildren([
      clinicDashboardRoute,
      clinicAppointmentsRoute,
      clinicAppointmentsOverviewRoute,
      clinicAppointmentsDetailsRoute,
      clinicDoctorsRoute,
      clinicPatientsRoute,
      clinicStaffRoute,
      ClinicOrdersDashboardRoute,
      ClinicOrdersRoute,
      ClinicOnlineOrderRoute,
      ClinicOfflineOrderRoute,
      ClinicLabTestOrderRoute,
      ClinicOfflineLabTestOrderRoute,
      ClinicOrdersLabTestsRoute,
      // ClinicOrdersProductsRoute,
      ClinicMedicineOrderReportRoute,
      ClinicLabTestOrderReportRoute,
      ClinicDaywiseReportRoute,
      ClinicStockReportRoute,
      ClinicAppointmentReportRoute,
      ClinicOrdersDeliveryBoysRoute,
      clinicStocksInventoryManagementRoute,
      clinicImagePreviewRoute,
      clinicTransactionHistoryRoute
    ]),
    adminRoute.addChildren([
      blogRoute,
      adminDashboardRoute,
      adminAppointmentsRoute,
      adminAppointmentsOverviewRoute,
      adminAppointmentsDetailsRoute,
      adminDoctorsRoute,
      adminPatientsRoute,
      adminClinicsRoute,
      adminStaffRoute,
      videoBlogsRoute,
      // adminSupervisorRoute,
      adminMedicalCampRoute,
      adminStocksDashboardRoute,
      adminStocksInventoryManagementRoute,
      adminStocksOrdersRoute,
      adminStocksOnlineOrdersRoute,
      adminStocksOfflineOrdersRoute,
      adminStockLabtestOrderRoute,
      adminOfflineLabtestOrderRoute,
      adminStocksCategoriesRoute,
      adminStocksProductsRoute,
      adminStocksLabTestsRoute,
      adminStocksMedicineRoute,
      AdminMedicineOrderReportRoute,
      AdminLabTestOrderReportRoute,
      AdminDaywiseReportRoute,
      AdminStockReportRoute,
      AdminAvailableStockReportRoute,
      AdminAppointmentReportRoute,
      // adminStocksNewItemRoute,
      adminStocksPromotionsRoute,
      adminStocksDeliveryBoysRoute,
      adminImagePreviewRoute,
      adminOrderManagementRoute,
      adminSearchAnalyticsRoute,
      adminProductEnquiryAnalyticsRoute,
      adminReviewAnalyticsRoute,
      adminTransactionHistoryRoute
    ]),
    campRoute.addChildren([campDashboardRoute, campAppointmentsRoute, campAppointmentsOverviewRoute, campAppointmentsDetailsRoute, campDoctorsRoute, campPatientsRoute]),
    labRoute.addChildren([labDashboardRoute]),
  ]),
]);

export const router = new Router({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
